// import route from '@/routeee.js'

const getters = {
  sidebar: state => state.app.sidebar,
  // size: state => state.app.size,
  // device: state => state.app.device,
  // visitedViews: state => state.tagsView.visitedViews,
  // cachedViews: state => state.tagsView.cachedViews,
  // showRightPanel: state => state.settings.showRightPanel,
  // cashier

  // User
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  full_name: state => state.user.full_name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  tab: state => state.mci.tab,

  // Cashier
  cashier: state => state.cashier.customerInfo,
  rowSelected: state => state.cashier.rowSelected,
  tabList: state => state.cashier.tabList,
  selectedTab: state => state.cashier.selectedTab,
  allTranPages: state => state.cashier.allTranPages,
  transactions: state => state.cashier.transactions,
  key: state => state.cashier.key,
  transactionListIndex: state => state.cashier.transactionListIndex,
  postTransactionCustomerListIndex: state =>
    state.cashier.postTransactionCustomerListIndex
}
export default getters
